export const V1_REQUEST_SEAT_TRADE_SEARCH_RESULTS =
  'V1_REQUEST_SEAT_TRADE_SEARCH_RESULTS'

export default data => {
  return {
    type: V1_REQUEST_SEAT_TRADE_SEARCH_RESULTS,
    data,
  }
}
